import {
    BoostMetricsProfilerContext,
    BoostMetricsProfilerContextModel,
    MetricDimension
} from "@amzn/awsboost-ui-metrics";
import { useContext, useEffect, useRef } from "react";

export interface CounterMetricsProps {
    method: string;
    metricName: string;
    metricValue: number;
    timeStamp?: Date;
    metricDimentions?: MetricDimension[];
}

interface MetricsProfilerProps {
    recordMetric: (metricsNamespace: string, metricName: string, metricValue: number, metricUnit: "Count" | "Milliseconds", metricDimentions?: MetricDimension[], Timestamp?: Date) => void,
    counterMetrics: (props: CounterMetricsProps) => void,
    timerMetrics: (props: CounterMetricsProps) => void
}

const METRIC_NAMESPACE = 'unified-receive';

export const useMetricsProfiler = (): MetricsProfilerProps | null => {
    const context = useContext<BoostMetricsProfilerContextModel | undefined>(BoostMetricsProfilerContext);
    const metricsProfiler = useRef<MetricsProfilerProps | null>(null);

    useEffect(() => {
        const recordMetric = (metricsNamespace: string, metricName: string, metricValue: number, metricUnit: "Count" | "Milliseconds", metricDimentions?: MetricDimension[], Timestamp?: Date) => {
            if (context) {
                context.addMetricHandler(metricsNamespace, metricName, metricValue, metricUnit, metricDimentions, Timestamp);
            } else {
                console.warn("Boost Metrics context is not available");
            }
        };

        const counterMetrics = ({ method, metricName, metricValue, timeStamp, metricDimentions }: CounterMetricsProps) => {
            recordMetric(METRIC_NAMESPACE, `${method}-${metricName}`, metricValue, "Count", metricDimentions, timeStamp)
        }

        const timerMetrics = ({ method, metricName, metricValue, timeStamp, metricDimentions }: CounterMetricsProps) => {
            recordMetric(METRIC_NAMESPACE, `${method}-${metricName}`, metricValue, "Milliseconds")
        }

        metricsProfiler.current = {
            recordMetric,
            counterMetrics,
            timerMetrics,
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if (!context) {
        return null;
    }

    return metricsProfiler.current;
};
